import * as React from 'react';
import { styled, Box, Typography } from '@mui/material';

const AdminHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 250, // Increased height for a more prominent header
  background: `radial-gradient(ellipse at center, ${theme.palette.primary.light} 0%, ${theme.palette.background.default} 70%)`,
  ...theme.applyStyles('dark', {
    background: `radial-gradient(ellipse at center, ${theme.palette.primary.dark} 0%, ${theme.palette.background.default} 70%)`,
  }),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(4),
}));

const AdminHeaderContent: React.FC = () => {
  return (
    <AdminHeader>
      <Typography
        variant="h3"
        sx={{
          color: (theme) =>
            theme.palette.mode === 'dark'
              ? theme.palette.primary.contrastText
              : theme.palette.text.primary,
          fontWeight: 700,
          mb: 1,
        }}
      >
        Admin Dashboard
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: (theme) =>
            theme.palette.mode === 'dark'
              ? theme.palette.primary.contrastText
              : theme.palette.text.primary,
        }}
      >
        Manage and monitor your application effortlessly.
      </Typography>
    </AdminHeader>
  );
};

export default AdminHeaderContent;
